<template>
  <div>
    <button
      @click="toggleIntoView(true)"
      style="display: block; margin: 0 auto 20px"
      class="form-item btn btn-outline-dark"
      type="submit"
    >
      Dodaj usługę
    </button>
    <div v-if="userById.user_services && userById.user_services.length > 0">
      <div class="">
        <h2>Usługi użytkownika</h2>
      </div>

      <table class="table borderless modal-table">
        <thead>
          <tr class="tr-table">
            <th scope="col">Cena</th>
            <th scope="col">ID usługi</th>
            <th scope="col">Kategoria</th>
            <th scope="col">Podkategoria</th>
            <th scope="col">Nazwa usługi</th>
            <th scope="col">Opis usługi</th>
            <th scope="col">Pierwszy próg</th>
            <th scope="col">Drugi próg</th>
            <th scope="col">Typ</th>
            <th scope="col"></th>
            <th scope="col">Weryfikacja PWZ</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in userById.user_services" v-bind:key="item.id">
            <td>{{ item.price }}</td>
            <td>{{ item.service.id }}</td>
            <td>
              {{
                item.service.serviceCategoryEntity
                  ? item.service.serviceCategoryEntity.display_name
                  : "Brak"
              }}
            </td>
            <td>
              {{
                item.service.sub_category
                  ? item.service.sub_category.display_name
                  : "Brak"
              }}
            </td>
            <td>{{ item.service.display_name }}</td>
            <td>{{ item.service.description || "Brak" }}</td>
            <td>{{ item.service.first_threshold }}</td>
            <td>{{ item.service.second_threshold }}</td>
            <td>{{ item.service.type }}</td>
            <td class="action-buttons">
              <button
                @click="startEditingProcess(item)"
                class="btn btn-sm btn-outline-dark"
              >
                EDYTUJ
              </button>
              <button
                @click="removeService(item)"
                class="btn btn-sm btn-outline-dark"
              >
                USUŃ
              </button>
            </td>
            <td>
              <p v-if="!item.service.need_verification">
                Nie wymaga weryfikacji
              </p>

              <button
                v-else-if="item.waiting_for_accept"
                @click="acceptServicePwz(item)"
                class="btn btn-sm btn-outline-dark"
                data-toggle="modal"
                :data-target="pwzModalTarget(item)"
              >
                ZWERYFIKUJ
              </button>
              <button
                v-else-if="!item.waiting_for_accept"
                @click="notAcceptServicePwz(item)"
                class="btn btn-sm btn-outline-dark"
                data-toggle="modal"
                data-target="#not-verify-pwz-modal"
              >
                COFNIJ WERYFIKACJĘ
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="dodUser && hasConnectedDodUser" class="dod-user">
      <h1>Połączone konto PA DOD</h1>
      <div class="connected-profile">
        <p class="connected-profile-label">Profil połączono</p>
        <button
          @click="removeDodAccount()"
          class="form-item btn btn-outline-dark"
        >
          Rozłącz
        </button>
      </div>
      <profile-preview
        :name="`${dodUser.firstName} ${dodUser.lastName}`"
        :phone="`${dodUser.phone}`"
      />
    </div>

    <div v-if="podUser && hasConnectedPodUser" class="dod-user">
      <h1>Połączone konto PA POD</h1>
      <div class="connected-profile">
        <p class="connected-profile-label">Profil połączono</p>
        <button
          @click="removePodAccount()"
          class="form-item btn btn-outline-dark"
        >
          Rozłącz
        </button>
      </div>
      <profile-preview
        :name="`${podUser.firstName} ${podUser.lastName}`"
        :phone="`${podUser.phone}`"
      />
    </div>
    <div
      id="adding-service-window"
      style="display: flex; align-items: center; justify-content: center"
      class=""
    >
      <div
        v-if="showAdd || showEdit"
        class="comission"
        style="margin-right: 1rem"
      >
        <h5
          style="padding-left: 5px"
          v-if="userById.user_profile && userById.user_profile.profile"
        >
          Dodaj/edytuj usługę
        </h5>

        <div class="commission-container">
          <form class="topform" @submit.prevent="">
            <div v-if="userCommissionMessage" class="text-danger">
              {{ userCommissionMessage }}
            </div>
            <div v-if="serviceCategoriesToSelect.length > 0">
              <div class="" v-if="showAdd">
                <label style="flex: 0 0 auto; margin: 0px">Usługa</label>
                <select
                  v-if="showAdd || (showEdit && chosenService.category.name)"
                  v-model="chosenService.category"
                  style="width: 300px; margin-left: -5px"
                  class="form-control"
                  name=""
                  id=""
                >
                  <option
                    :value="service"
                    v-for="service in serviceCategoriesToSelect"
                    :key="service.name"
                  >
                    {{ service.display_name }}
                  </option>
                </select>
              </div>
              <div class="" v-if="showEdit">
                <label style="flex: 0 0 auto; margin: 0px">Usługa</label>
                <select
                  style="width: 300px; margin-left: -5px"
                  disabled="true"
                  v-if="showAdd || (showEdit && chosenService.category.name)"
                  v-model="chosenService.category.name"
                  class="form-control"
                  name=""
                  id=""
                >
                  <option
                    :value="service.name"
                    v-for="service in serviceCategoriesToSelect"
                    :key="service.name"
                  >
                    {{ service.display_name }}
                  </option>
                </select>
              </div>
              <label
                v-if="
                  chosenService.category.name &&
                  chosenService.sub_category &&
                  chosenService.sub_category !== null &&
                  hasSelectedCategorySubCategories
                "
                style="flex: 0 0 auto; margin: 0px"
                >Opcja usługi</label
              >
              <select
                v-if="
                  chosenService.category.name &&
                  chosenService.sub_category &&
                  chosenService.sub_category !== null &&
                  hasSelectedCategorySubCategories
                "
                v-model="chosenService.sub_category.name"
                class="form-control mb-4"
                style="width: 300px"
                name=""
                id=""
              >
                <option
                  :value="service.name"
                  v-for="service in subCategories"
                  :key="service.name"
                >
                  {{ service.display_name }}
                </option>
              </select>

              <label
                v-if="
                  (chosenService.category.name &&
                    !hasSelectedCategorySubCategories) ||
                  (chosenService.sub_category.name &&
                    hasSelectedCategorySubCategories)
                "
                style="flex: 0 0 auto; margin: 0px"
                >Opcja</label
              >
              <select
                name="filtering"
                style="width: 300px"
                class="form-control categorySelect mapInput"
                v-model="chosenService.id"
                v-if="
                  (chosenService.category.name &&
                    !hasSelectedCategorySubCategories) ||
                  (chosenService.sub_category.name &&
                    hasSelectedCategorySubCategories)
                "
              >
                <option
                  v-for="option in allServices"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.display_name }}
                  <span v-if="option.is_hidden">(ukryta w aplikacji)</span>
                  <span
                    v-if="
                      option.display_name !== option.description &&
                      option.description.length < 35
                    "
                    >{{ option.description }}</span
                  >
                </option>
              </select>

              <label style="flex: 0 0 auto; margin: 0px">Cena</label>
              <input
                v-model="chosenService.price"
                id="commissionDate"
                type="number"
                class="form-control"
                required
                minlength="1"
                placeholder="Cena usługi"
              />
            </div>
            <button
              style="background: rgba(9, 7, 65, 0.05); width: 100px"
              class="form-item btn"
              @click="clearAddCommissionWindow"
            >
              Anuluj
            </button>
            <button
              style="width: 100px"
              @click="addNewCommission"
              class="form-item btn btn-outline-dark"
            >
              Zapisz
            </button>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addNewSms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewSms"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewSms">Edytuj promień</h5>
            <button
              id="button-close-modal"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="addNewSmsForm" @submit.prevent="editRadius">
              <div class="input-container">
                <input
                  v-model="userById.user_profile.profile.distance"
                  id="title"
                  class="form-control"
                  type="number"
                  required
                  minlength="9"
                  maxlength="9"
                  placeholder="Numer telefonu"
                />
              </div>

              <button
                class="buttonm btn btn-outline-dark addNewSmsButton"
                type="submit"
              >
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <custom-modal :title="'Czy zweryfikować PWZ?'" :id="'verify-pwz-modal'">
      <template #content>
        <p class="ml-2" v-if="selectedUserService">
          Czy chcesz zweryfikować PWZ usługi
          <b>{{ selectedUserService.service.display_name }}</b
          >?
        </p>
        <div class="modal-buttons">
          <custom-button
            @click="closeVerifyPwzModal()"
            :size="'small'"
            :title="'NIE'"
            :gray="true"
            :customStyles="'width: 50%'"
          />
          <custom-button
            @click="confirmAcceptServicePwz()"
            :size="'small'"
            :title="'TAK'"
            :gradient="true"
            :customStyles="'width: 50%'"
          />
        </div>
      </template>
    </custom-modal>

    <custom-modal
      :title="'Czy cofnąć weryfikację PWZ?'"
      :id="'not-verify-pwz-modal'"
    >
      <template #content>
        <p class="ml-2" v-if="selectedUserService">
          Czy chcesz cofnąć weryfikację PWZ usługi
          <b>{{ selectedUserService.service.display_name }}</b
          >?
        </p>
        <div class="modal-buttons">
          <custom-button
            @click="closeNotVerifyPwzModal()"
            :size="'small'"
            :title="'NIE'"
            :gray="true"
            :customStyles="'width: 50%'"
          />
          <custom-button
            @click="confirmNotAcceptServicePwz()"
            :size="'small'"
            :title="'TAK'"
            :gradient="true"
            :customStyles="'width: 50%'"
          />
        </div>
      </template>
    </custom-modal>

    <custom-modal :title="'Czy zweryfikować PWZ?'" :id="'verify-pwz-dod-modal'">
      <template #content>
        <verify-pwz-dod-modal
          :phone="userById.user_profile.user.phone"
          :selectedUserService="selectedUserService"
          @servicesUpdated="handleServicesUpdated"
        />
      </template>
    </custom-modal>

    <custom-modal :title="'Czy zweryfikować PWZ?'" :id="'verify-pwz-pod-modal'">
      <template #content>
        <verify-pwz-dod-modal
          panel="POD"
          :phone="userById.user_profile.user.phone"
          :selectedUserService="selectedUserService"
          @servicesUpdated="handleServicesUpdated"
        />
      </template>
    </custom-modal>
  </div>
</template>

<script>
import shared from "../shared";
//import { URL } from "../axios";
import axios from "../axios";
import CustomModal from "./CustomModal.vue";
import CustomButton from "./CustomButton.vue";
import VerifyPwzDodModal from "./VerifyPwzDodModal.vue";
import ProfilePreview from "./ProfilePreview.vue";
export default {
  components: { CustomModal, CustomButton, VerifyPwzDodModal, ProfilePreview },
  name: "EmployeeServices",
  emits: ["servicesUpdated"],
  props: {
    userById: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAdd: false,
      showEdit: false,
      serviceCategoriesToSelect: [],
      chosenService: {
        category: { name: "", display_name: "", id: "" },
        sub_category: { name: "", display_name: "", id: "" },
        id: "",
        name: "",
        display_name: "",
        price: "",
      },
      commission: 0,
      commission_valid_date: 0,
      selectedUserService: null,
    };
  },
  async created() {
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.formattedDate = shared.formattedDate;
    await this.$store.dispatch("getAllServices");
    await this.$store.dispatch("getAllSubCategories");
    await this.$store.dispatch("getDodUserByPhoneNumber", {
      phone: this.userById.user_profile.user.phone,
    });
    await this.$store.dispatch("getPodUserByPhoneNumber", {
      phone: this.userById.user_profile.user.phone,
    });
    await this.$store
      .dispatch("fetchServiceCategoriesWithServices")
      .then(() => {
        this.serviceCategories.forEach((serviceCategory) => {
          if (
            !serviceCategory.is_hidden &&
            (serviceCategory.type === null ||
              serviceCategory.type === "NONE" ||
              serviceCategory.type === "FUNDACJA" ||
              serviceCategory.type === "SPOLKA")
          ) {
            this.serviceCategoriesToSelect.push({
              id: serviceCategory.id,
              name: serviceCategory.name,
              display_name: serviceCategory.display_name,
            });
          }
        });
        this.serviceCategoriesToSelect.sort((item1, item2) => {
          if (item1.display_name < item2.display_name) return -1;
          if (item1.display_name > item2.display_name) return 1;
          return 0;
        });
      });
  },
  methods: {
    handleServicesUpdated() {
      this.$emit("servicesUpdated");
    },
    // Usluga Fundacji weryfikuje sie przez modal PA DOD, uslug Spolki przez PA POD,
    // pozostale zwyklym modalem PWZ.
    pwzModalTarget(item) {
      const type =
        item.service && item.service.serviceCategoryEntity
          ? item.service.serviceCategoryEntity.type
          : null;
      if (type === "FUNDACJA") return "#verify-pwz-dod-modal";
      if (type === "SPOLKA") return "#verify-pwz-pod-modal";
      return "#verify-pwz-modal";
    },
    async removeDodAccount() {
      await axios.put(
        `/api/dod/users/phone/${this.dodUser.phone}/setDodUserId`,
        {
          id: null,
        }
      );

      await this.$store.dispatch("getDodUserByPhoneNumber", {
        phone: this.userById.user_profile.user.phone,
      });
    },
    async removePodAccount() {
      await axios.put(
        `/api/pod/users/phone/${this.podUser.phone}/setPodUserId`,
        {
          id: null,
        }
      );

      await this.$store.dispatch("getPodUserByPhoneNumber", {
        phone: this.userById.user_profile.user.phone,
      });
    },
    closeVerifyPwzModal() {
      this.selectedUserService = null;
      document.getElementById("verify-pwz-modal-close").click();
    },
    async confirmAcceptServicePwz() {
      try {
        const item = this.selectedUserService;
        await axios.put(`/api/userService/${item.id}/pwz/accept`);
        this.$notify({
          group: "success",
          text: "Pomyślnie zweryfikowano usługę.",
        });

        await this.$store.dispatch("getDodUserByPhoneNumber", {
          phone: this.userById.user_profile.user.phone,
        });

        this.$emit("servicesUpdated");
        this.closeVerifyPwzModal();
      } catch (error) {
        console.log(error);
      }
    },
    closeNotVerifyPwzModal() {
      this.selectedUserService = null;
      document.getElementById("not-verify-pwz-modal-close").click();
    },
    async confirmNotAcceptServicePwz() {
      try {
        const item = this.selectedUserService;
        const categoryType =
          item.service && item.service.serviceCategoryEntity
            ? item.service.serviceCategoryEntity.type
            : null;
        await axios.put(`/api/userService/${item.id}/pwz/notAccept`);

        // Cofniecie weryfikacji uslugi DNR odpina konto WLASCIWEGO panelu:
        // Fundacja -> PA DOD, Spolka -> PA POD. Inne uslugi nie ruszaja polaczen.
        if (categoryType === "FUNDACJA" && this.dodUser) {
          await axios.put(
            `/api/dod/users/phone/${this.dodUser.phone}/setDodUserId`,
            {
              id: null,
            }
          );
        }
        if (categoryType === "SPOLKA" && this.podUser) {
          await axios.put(
            `/api/pod/users/phone/${this.podUser.phone}/setPodUserId`,
            {
              id: null,
            }
          );
        }
        this.$notify({
          group: "success",
          text: "Pomyślnie cofnięto weryfikację usługi.",
        });
        await this.$store.dispatch("getDodUserByPhoneNumber", {
          phone: this.userById.user_profile.user.phone,
        });
        await this.$store.dispatch("getPodUserByPhoneNumber", {
          phone: this.userById.user_profile.user.phone,
        });
        this.$emit("servicesUpdated");
        this.closeNotVerifyPwzModal();
      } catch (error) {
        console.log(error);
      }
    },

    acceptServicePwz(item) {
      this.selectedUserService = item;
    },

    notAcceptServicePwz(item) {
      this.selectedUserService = item;
    },

    editRadius() {
      let closer = window.document.getElementById("button-close-modal");
      if (this.userById.user_profile.profile.distance) {
        axios
          .put(`api/admin/users/${this.userById.user_profile.user.id}`, {
            distance: this.userById.user_profile.profile.distance,
          })
          .then(async () => {
            this.$notify({
              group: "success",
              text: "Pomyślnie edytowano promień usługę.",
            });
            this.$emit("servicesUpdated");
            closer.click();
          })
          .catch((err) => {
            console.log(err.response);
          });
      }
    },
    addNewCommission() {
      let url = `api/admin/users/${this.userById.user_profile.user.id}/userServices`;
      const body = {
        serviceId: this.chosenService.id,
        price: this.chosenService.price,
      };
      axios
        .put(url, body)
        .then(async () => {
          this.$notify({
            group: "success",
            text: "Pomyślnie dodano/edytowano usługę.",
          });
          this.$emit("servicesUpdated");
          this.clearAddCommissionWindow();
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    clearAddCommissionWindow() {
      this.chosenService = {
        category: { name: "", display_name: "", id: "" },
        sub_category: { name: "", display_name: "", id: "" },
        id: "",
        price: "",
      };
      this.showEdit = false;
      this.showAdd = false;
    },
    toggleIntoView(isAdd) {
      if (isAdd) this.showAdd = true;
      setTimeout(() => {
        document
          .getElementById("adding-service-window")
          .scrollIntoView({ behavior: "smooth" });
      }, 500);
    },
    startEditingProcess(commission) {
      this.chosenService.id = commission.service.id;
      this.chosenService.name = commission.service.name;
      this.chosenService.display_name = commission.service.display_name;
      this.chosenService.price = commission.price;
      this.chosenService.category = commission.service.serviceCategoryEntity;
      this.chosenService.sub_category = commission.service.sub_category;
      this.showAdd = false;
      this.showEdit = true;
      setTimeout(() => {
        document
          .getElementById("adding-service-window")
          .scrollIntoView({ behavior: "smooth" });
      }, 500);
    },

    async removeService(service) {
      try {
        const confirmMessage = "USUŃ";
        const confirmed = prompt(
          `Czy na pewno chcesz usunąć usługę opiekuna "${service.service.display_name}"? Potwierdź wpisująć "USUŃ"`,
          ""
        );

        if (confirmed === confirmMessage) {
          axios
            .delete(`/api/admin/userServices/${service.id}`)
            .then(async () => {
              this.$notify({
                group: "success",
                text: "Pomyślnie usunięto usługę.",
              });
              this.$emit("servicesUpdated");
            })
            .catch((err) => {
              console.log(err.response);
            });
        }
      } catch (err) {
        console.log(err);
        this.$notify({
          group: "success",
          text: "Nie udało się usunąć usługi",
        });
      }
    },
  },
  computed: {
    hasConnectedDodUser() {
      return (
        this.userById.user_profile.user.dod_user_id &&
        this.dodUser.mainAppUserId
      );
    },
    dodUser() {
      return this.$store.getters.getDodUser;
    },
    hasConnectedPodUser() {
      return (
        this.userById.user_profile.user.pod_user_id &&
        this.podUser.mainAppUserId
      );
    },
    podUser() {
      return this.$store.getters.getPodUser;
    },
    userCommissionMessage() {
      return this.$store.getters.getUserCommissionMessage;
    },
    serviceCategories() {
      return this.$store.getters.getServiceCategoryWithServices;
    },
    hasSelectedCategorySubCategories() {
      const serviceCategoryId = this.chosenService.category.id;
      const serviceCategory = this.serviceCategories.filter(
        (sc) => sc.id === serviceCategoryId
      )[0];
      if (
        serviceCategory &&
        serviceCategory.sub_categories &&
        serviceCategory.sub_categories.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    subCategories() {
      const serviceCategoryId = this.chosenService.category.name;
      const subCategories = this.$store.getters.getAllSubCategories;
      return subCategories.filter((subCategory) => {
        if (
          subCategory.service_category.name === serviceCategoryId &&
          !subCategory.is_hidden &&
          (subCategory.service_category.type === null ||
            subCategory.service_category.type === "NONE")
        )
          return subCategory;
      });
    },
    allServices() {
      let subCategoryId = "";
      const serviceCategoryId = this.chosenService.category.id;
      if (
        this.chosenService.sub_category &&
        this.chosenService.sub_category !== null
      ) {
        subCategoryId = this.chosenService.sub_category.name;
      }
      const services = this.$store.getters.getAllServices;
      if (
        this.chosenService.sub_category &&
        this.chosenService.sub_category.name
      ) {
        // Ukryte uslugi zostaja na liscie (zgloszenie 15.09.2026): wycofany z oferty wariant obiadow
        // wciaz obsluguje trwajace abonamenty, wiec restauracja musi dac sie do niego podpiac. Lista
        // przychodzi z with_hidden=true, a ten filtr byl jedynym miejscem, ktore je odsiewalo.
        return services.filter((service) => {
          if (
            (service.serviceCategoryEntity.type === null ||
              service.serviceCategoryEntity.type === "NONE") &&
            service.sub_category &&
            service.sub_category.name === subCategoryId
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return services.filter((service) => {
          if (
            service.serviceCategoryEntity &&
            service.serviceCategoryEntity.id === serviceCategoryId
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
  height: 100%;
}
.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.connected-profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-left: 0px;
}
.connected-profile-label {
  color: #0ea754;
  font-size: 16px;
  margin-top: 1rem;
}
.dod-user {
  width: 250px;
}
</style>